export function prettifyDate(date: Date | undefined)
{
    if (!date) return undefined;
    return (date.toLocaleDateString("en-ZA"));
}
